export default __webpack_public_path__ + "static/media/reconciliation-of-share-capital-audit-report-1.6cb5e93c.pdf";